import * as _ from "lodash";

export const getFullName = (user) => `${_.get(user, 'firstName', "") + " " + _.get(user, 'lastName', "")}`;